import React from 'react';

import DataInfo from '../../shared/displayComponents/dataInfo/dataInfo.component';

const WaitingUpload = () => <DataInfo textToRender="Your file is waiting to be processed" />;

export default WaitingUpload;
